<template>
  <div class="enterprise-container">
    <div class="enterprise-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/enterprise-banner.png"
        alt=""
      />
      <div class="banner-wordbox">
        <div class="banner-wordbox-content">
          <h2 class="banner-title">企事业图书馆解决方案</h2>
          <p class="banner-desc" style="width:34.4rem">
            企事业图书馆方案，可建设企业文化
            ，树立“用文化管企业”、“以文化兴企业”的理念。企业文化，是企业综合实力的体现；阅读可建设学习型企业，让企业更好的创新、拥抱行业变化，提高职工向心力、凝聚力，使得企业长青。
          </p>
        </div>
      </div>
    </div>
    <!-- 为什么要建设企事业图书馆 -->
    <div class="enterprise-container-reason">
      <h2 class="enterprise-container-reason-title title-common">
        为什么要建设企事业图书馆
      </h2>
      <ul class="enterprise-container-reason-content">
        <li v-for="(item, i) in reasonList" :key="i">
          <div class="enterprise-container-reason-content-img">
            <img :src="item.pic" alt="" />
          </div>
          <p>{{ item.title }}</p>
        </li>
      </ul>
    </div>
    <!-- 技术方案 -->
    <div class="enterprise-container-proposal">
      <h2 class="enterprise-container-proposal-title title-common">
        技术方案
      </h2>
      <div class="enterprise-container-proposal-content">
        <ul class="enterprise-container-proposal-content-list">
          <li v-for="(item, i) in productList" :key="i">
            <img :src="item.pic" alt="" />
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 方案特点 -->
    <div class="enterprise-container-features">
      <h2 class="enterprise-container-features-title title-common">
        方案特点
      </h2>
      <ul class="enterprise-container-features-list">
        <li v-for="(item, i) in featureList" :key="i">
          <img :src="item.pic" alt="" />
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </li>
      </ul>
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
  data() {
    return {
      reasonList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-reason-item1.png",
          title: "提高职工归属感",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-reason-item2.png",
          title: "提升职工素质与能力",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-reason-item3.png",
          title: "提升单位整体形象",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-reason-item4.png",
          title: "推进“全民阅读”",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-reason-item5.png",
          title: "建立公司文化基地",
        },
      ],
      productList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item1.png",
          name: "RFID标签和读者证",
          introduction:
            "智能RFID标签在图书馆行业的应用，大大改变了整个书籍流通的效率，迈向互联时代。RFID分高频和超高频，在书籍中、读者证中、层架标签中都采用了RFID芯片和通信机制。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item2.png",
          name: "RFID手持盘点仪",
          introduction:
            "一体化馆员工作站是将RFID读写板、图书标签转换系统和显示屏结合的智能一体机。可对图书标签和读者证卡进行编写、识别和流通状态处理，用于图书的标签转换及图书人工借还状态处理。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item3.png",
          name: "桌面式RFID借还办证一体机",
          introduction:
            "自助借还一体机采用立体式设计，提供便捷化的操作模式和友好的图形界面，集借还书、检索、缴费、电子书借阅等多功能于一体，同时满足图书流通的多种业务需求，为读者提供智能化的自助服务。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item4.png",
          name: "可刷脸闸机",
          introduction:
            "自助借还一体机采用立体式设计，提供便捷化的操作模式和友好的图形界面，集借还书、检索、缴费、电子书借阅等多功能于一体，同时满足图书流通的多种业务需求，为读者提供智能化的自助服务。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item5.png",
          name: "安全门禁",
          introduction:
            "智能书架产品以RFID技术为核心，结合工控机、网络控制、灯光控制、冲压结构等形成的可以对图书进行自动盘点和查询的高性能智能图书存放产品。该产品可以大大降低图书盘点时间，有效节约了借阅者的查书时间，真正做到了对图书管理的智能化和高效化。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item6.png",
          name: "企业书屋图书管理系统",
          introduction:
            "24小时自助还书机是一款人性化、智能化的还书设备，读者还书将不再受图书馆开、闭管时间的限制，可在任意时间还书。设备可配合自动分拣设备和码放设备使读者还回的图书自动分进不同的还书车，大大降低图书馆工作人员的工作量，提升效率。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item7.png",
          name: "RFID智能书架",
          introduction:
            "智能盘点设备能够方便图书工作人员进行图书上架、图书盘点、统计查询等工作。移动盘点车可搭配多个手持盘点终端，满足多人同时协同盘点。盘点系统支持与手机排架系统无缝对接，准确定位图书位置，便于读者快速查找图书。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item8.png",
          name: "微信图书馆",
          introduction:
            "智能盘点设备能够方便图书工作人员进行图书上架、图书盘点、统计查询等工作。移动盘点车可搭配多个手持盘点终端，满足多人同时协同盘点。盘点系统支持与手机排架系统无缝对接，准确定位图书位置，便于读者快速查找图书。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-proposal-item9.png",
          name: "大数据显示平台",
          introduction: "",
        },
      ],
      featureList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-feature-item1.png",
          title: "一卡多用",
          desc: "企业都有员工卡，图书管理软件支持员工卡代替借阅卡使用",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-feature-item2.png",
          title: "数据后台",
          desc: "后台可查看员工图书借阅情况，借阅排行",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/enterprise/enterprise-feature-item3.png",
          title: "助力格局升级",
          desc: "节约成本、响应全民阅读政策，提升单位格局",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libEnterprise.scss";
</style>
